import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { SectionHeading } from './SectionHeading';
import { tomos, tomoIncludes } from '../data/content';
export function TomosSection() {
  return <section aria-labelledby="tomos" className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-12 text-center" data-id="element-249" data-mp="1p4v7cp8lzity">
      <Reveal data-id="element-250" data-mp="1u4rbqpl7xca1">
        <SectionHeading id="tomos" eyebrow="Un sistema progresivo para observarte, elegirte y volver" title="4 Tomos completos" data-id="element-251" data-mp="xce0q1825z9v" />
      </Reveal>

      <ol className="mt-8 grid gap-3 md:grid-cols-2" data-id="element-252" data-mp="11g29uocc92x8">
        {tomos.map((tomo, i) => <Reveal key={tomo.title} as="li" delay={i * 0.03} className="flex h-full flex-col items-center rounded-2xl border border-line bg-surface p-6 text-center" data-id="element-253" data-mp="16brc4zfqsxx8" data-mpi={i}>
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-blush" data-id="element-254" data-mp="2mrc49tdfjuf6">
              Tomo {i + 1}
            </span>
            <h3 className="mt-2 font-display text-xl font-bold uppercase leading-tight text-ink" data-id="element-255" data-mp="2qoidfh8yaht3">
              {tomo.title}
            </h3>
            <p className="mt-1 text-sm font-semibold text-accent" data-id="element-256" data-mp="2mkiyh33bjr1u">
              {tomo.lead}
            </p>
            <p className="mt-2 text-sm leading-relaxed text-ink-muted" data-id="element-257" data-mp="2hpdei9th8mge">
              {tomo.desc}
            </p>
            <ul className="mt-4 flex flex-wrap justify-center gap-2" data-id="element-258" data-mp="27pcsgg483s8i">
              {tomo.includes.map(item => <li key={item} className="flex items-center gap-1.5 rounded-full bg-surface-alt px-3 py-1.5 text-xs text-ink-muted" data-id="element-259" data-mp="22y4fxb7ljqr4">
                  <CheckIcon size={12} className="flex-shrink-0 text-accent" strokeWidth={3} data-id="element-260" data-mp="1ty7ynunjdu63" />
                  {item}
                </li>)}
            </ul>
            <p className="mt-auto pt-5 text-sm font-bold uppercase tracking-wide text-gold" data-id="element-261" data-mp="1k0brfdxpzjd9">
              Valor {tomo.value}
            </p>
          </Reveal>)}
      </ol>

      <Reveal className="mt-6 rounded-2xl border border-line bg-surface-alt p-6 md:p-8" data-id="element-262" data-mp="1fcak89p99wbq">
        <h3 className="font-display text-lg font-bold uppercase text-ink" data-id="element-263" data-mp="11c9o17jxrd2l">
          Cada tomo incluye
        </h3>
        <ul className="mx-auto mt-4 flex max-w-4xl flex-wrap justify-center gap-2" data-id="element-264" data-mp="15duti7u54p2r">
          {tomoIncludes.map(item => <li key={item} className="flex items-center gap-2 rounded-full bg-surface px-4 py-2 text-sm text-ink-muted" data-id="element-265" data-mp="1t4qu9ugkqum5">
              <CheckIcon size={13} className="flex-shrink-0 text-success" strokeWidth={3} data-id="element-266" data-mp="1k9aukwt51l8n" />
              <span data-id="element-267" data-mp="2c1jn5pltxtfy">{item}</span>
            </li>)}
        </ul>
      </Reveal>
    </section>;
}